import { Tooltip } from '@biq/apex-ui';
import { Typography } from '@mui/material';
import { styles as confirmationModalStyles } from 'components/confirmation-modal/confirmation-modal-helper';

const getChainNameLength = (chainName: string, length: number): boolean => {
    return chainName.length > length;
};

const getTruncatedChain = (chainName: string, length: number): string => {
    return getChainNameLength(chainName, length)
        ? chainName.slice(0, length) + '...'
        : chainName;
};

const getTruncatedTypography = (text: string): React.JSX.Element => {
    return (
        <Typography
            component='span'
            sx={{
                ...confirmationModalStyles.textBoldStyles,
                ...confirmationModalStyles.wordBreakStyles,
            }}
        >
            {text}
        </Typography>
    );
};

export const confirmationInputLabelText = (
    chainName: string,
    length: number
): React.JSX.Element => {
    return (
        <Typography
            sx={{
                ...confirmationModalStyles.textBoldStyles,
                ...confirmationModalStyles.maxWidthStyles,
            }}
        >
            {getChainNameLength(chainName, length) ? (
                <Tooltip title={chainName} arrow placement='top'>
                    {getTruncatedTypography(
                        `Type ${getTruncatedChain(chainName, length)} below`
                    )}
                </Tooltip>
            ) : (
                getTruncatedTypography(
                    `Type ${getTruncatedChain(chainName, length)} below`
                )
            )}
            <Typography
                component={'span'}
                sx={confirmationModalStyles.textFieldRequiredStyles}
            >
                *
            </Typography>
        </Typography>
    );
};

export const confirmationSubHeadingText = (
    chainName: string,
    length: number
): React.JSX.Element => {
    return (
        <Typography sx={confirmationModalStyles.maxWidthStyles}>
            By typing ‘
            {getChainNameLength(chainName, length) ? (
                <Tooltip title={chainName} arrow placement='top'>
                    {getTruncatedTypography(
                        `${getTruncatedChain(chainName, length)}`
                    )}
                </Tooltip>
            ) : (
                getTruncatedTypography(
                    `${getTruncatedChain(chainName, length)}`
                )
            )}
            ’ below, you understand that you are permanently deleting the
            dictionary and data on this chain. This action{' '}
            <Typography
                component='span'
                sx={confirmationModalStyles.textBoldStyles}
            >
                CANNOT
            </Typography>{' '}
            be undone.
        </Typography>
    );
};
